/* global: module */
(function() {
    function Flythrough(options) {
        var self = this;

        this.interval = null;

        this.frameWidth = options.frameWidth;
        this.frameHeight = options.frameHeight;
        this.frameImageWidth = options.frameImageWidth;
        this.frameImageHeight = options.frameImageHeight;

        this.hFrameCount = this.frameImageWidth / this.frameWidth;
        this.vFrameCount = this.frameImageHeight / this.frameHeight;
        this.frameCount = this.hFrameCount * this.vFrameCount;

        this.canvas = document.createElement("canvas");
        this.ctx = this.canvas.getContext("2d");

        this.resizeCanvas();

        this.currentFrame = 0;
        this.framesLoaded = false;
        this.framesImage = this.loadImage(options.image, function() {
            self.framesLoaded = true;
        });

        return this;
    }

    Flythrough.prototype.loadImage = function(image, callback) {
        var img = new Image();
        img.addEventListener("load", callback, false);

        if (typeof image === "string") {
            img.src = image;
        } else if (image.src) {
            img.src = image.src;
        }

        return img;
    };

    Flythrough.prototype.getCanvas = function() {
        return this.canvas;
    };

    Flythrough.prototype.render = function() {
        return this.renderFrame(this.currentFrame);
    };

    Flythrough.prototype.renderFrame = function(frame) {
        this.resizeCanvas();

        this.currentFrame = this.boundFrame(frame);
        this.drawFrame(this.currentFrame);
    };

    Flythrough.prototype.drawFrame = function(frame) {
        var xy = this.getCoords(frame),
            canvas = this.getCanvas(),
            self = this;

        if (this.framesLoaded) {
            this.ctx.drawImage(
                this.framesImage,
                xy[0],
                xy[1],
                this.frameWidth,
                this.frameHeight,
                0,
                0,
                canvas.width,
                canvas.height
            );
        } else {
            setTimeout(function() {
                self.drawFrame(frame);
            }, 20);
        }
    };

    Flythrough.prototype.getCoords = function(frame) {
        var x = frame % this.hFrameCount * this.frameWidth,
            y = (frame / this.hFrameCount | 0) * this.frameHeight;
        return [x, y];
    };

    Flythrough.prototype.isInDOM = function() {
        var canvas = this.getCanvas();

        return !!canvas.parentNode;
    };

    Flythrough.prototype.resizeCanvas = function() {
        var width = this.getWidth(),
            canvas = this.getCanvas();

        canvas.width = width;
        canvas.height = width / (this.frameWidth / this.frameHeight) | 0;

        return this;
    };

    Flythrough.prototype.getWidth = function() {
        var clientWidth, widthRegex, canvas, styles, temp,
            borderLeft = 0,
            borderRight = 0,
            width = this.frameWidth;

        if (this.isInDOM()) {
            canvas = this.getCanvas();
            clientWidth = canvas.clientWidth;
            styles = window.getComputedStyle(canvas, null);
            widthRegex = /^[\d]+/;
            temp = widthRegex.exec(styles.borderLeftWidth);
            if (temp) {
                borderLeft = parseInt(temp[0], 10);
            }
            temp = widthRegex.exec(styles.borderRightWidth);
            if (temp) {
                borderRight = parseInt(temp[0], 10);
            }

            if (clientWidth) {
                width = clientWidth;
                if (styles.boxSizing === "content-box") {
                    width -= (borderLeft + borderRight);
                }
            }
        }

        return width;
    };

    Flythrough.prototype.boundFrame = function(frame) {
        var temp, adjustedFrame;

        if (frame >= this.frameCount) {
            adjustedFrame = frame % this.frameCount;
        } else if (frame < 0) {
            temp = frame % this.frameCount;

            adjustedFrame = temp ? this.frameCount + temp : 0;
        } else {
            adjustedFrame = frame;
        }

        return adjustedFrame;
    };

    Flythrough.prototype.moveTo = function(frame) {
        var current = this.currentFrame,
            target = this.boundFrame(frame),
            forwardPath = target < current ? this.frameCount - current + target : target - current,
            backPath = target < current ? current - target : current + this.frameCount - target,
            transition = forwardPath <= backPath ? this.next : this.prev;

        clearInterval(this.interval);
        this.interval = null;

        transition.call(this, target);
    };

    Flythrough.prototype.next = function(target) {
        var self = this;

        this.interval = setInterval(function() {
            if (self.currentFrame !== target) {
                self.renderFrame(self.currentFrame + 1);
            } else {
                clearInterval(self.interval);
                self.interval = null;
            }
        }, 80);
    };

    Flythrough.prototype.prev = function(target) {
        var self = this;

        this.interval = setInterval(function() {
            if (self.currentFrame !== target) {
                self.renderFrame(self.currentFrame - 1);
            } else {
                clearInterval(self.interval);
                self.interval = null;
            }
        }, 80);
    };

    if (typeof module !== "undefined" && typeof exports !== "undefined") {
        module.exports = Flythrough;
    } else {
        window.Flythrough = Flythrough;
    }
}());
